export const getLmsClassUrl = (classId: string): string => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const isProd = backendUrl.includes('prod');

    if (isProd) {
        // Prod: performancemanager8.successfactors.com | company=1161975P | LMS: johndeere.plateau.com
        const destUrl = `https://johndeere.plateau.com/learning/user/deeplink_redirect.jsp?linkId=SCHEDULED_OFFERING_DETAILS&scheduleID=${classId}&fromSF=Y`;

        return `https://performancemanager8.successfactors.com/sf/learning?destUrl=${encodeURIComponent(destUrl)}&company=1161975P`;
    }

    // DCT2: hcm8preview.sapsf.com | company=deerecompaT2 | LMS: deerecompa-stage.plateau.com
    const destUrl = `https://deerecompa-stage.plateau.com/learning/user/deeplink_redirect.jsp?linkId=SCHEDULED_OFFERING_DETAILS&scheduleID=${classId}&fromSF=Y`;

    return `https://hcm8preview.sapsf.com/sf/learning?destUrl=${encodeURIComponent(destUrl)}&company=deerecompaT2`;
};
